import formRequest from '@/utils/formRequest'
import request from '@/utils/request-axios'
import api from '@/utils/api'

//登陆
export function loginForm(params) {
  return formRequest(`${api.loginForm}`, {
    loading: true,
    method: 'post',
    data: params
  });
}

//获取登录验证码
export function getLoginCode(params) {
  return formRequest(`${api.getLoginCode}${params}`, {
    loading: true,
    method: 'get',
  });
}


//退出登陆
export function logout() {
  return request(`${api.logout}`, {
    loading: true,
    method: 'delete',
  });
}


//刷新token
export function reToken(params) {
  return formRequest(`${api.reToken}`, {
    loading: true,
    method: 'post',
    data: params,
  })
}

//个人中心
export function rePhone(params) {
  return request(`${api.rePhone}`, {
    loading: true,
    method: 'put',
    data: params
  });
}

export function rePwd(params) {
  return request(`${api.rePwd}`, {
    loading: true,
    method: 'put',
    data: params
  });
}

export function getUserInfo(params) {
  return request(`${api.getUserInfo}`, {
    loading: true,
    method: 'get',
  });
}

export function editUserInfo(params) {
  return request(`${api.editUserInfo}`, {
    loading: true,
    method: 'put',
    data: params
  });
}

//详情
export function getEnterprise(params) {
  return request(`${api.getEnterprise}${params}`, {
    loading: true,
    method: 'get',
  });
}

//获取注册验证码
export function getRegCode(params) {
  return request(`${api.getRegCode}${params}`, {
    loading: true,
    method: 'get',
  });
}



// WEBPACK FOOTER //
// ./src/services/login.js